import { useEffect, useState } from "react";

const useMediaQuery = query => {
  const [value, setValue] = useState(false);

  useEffect(() => {
    const onChange = event => {
      setValue(event.matches);
    };

    const result = matchMedia(query);
    if (!result) {
      return;
    }
    result.addEventListener("change", onChange);
    setValue(result.matches);

    return () => result.removeEventListener("change", onChange);
  }, [query]);

  return value;
};

export default useMediaQuery;
